export default "__VITE_ASSET__Cxk4IfzT__"